import { useForm } from "react-hook-form";
import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addAssets } from '../../../store/assets/actions';
import { startUploadProgress } from "../../../store/global/actions";
import { Box, Typography, Button, Paper, List, ListItem, ListItemText } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/core/styles';
import { useDropzone } from 'react-dropzone';
import CustomizedDialogs from "../../atoms/dialog";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { getDetailsFromUrl } from "../../../services/blueprint";
import { getAssets } from "../../../store/assets/selectors";
const { generate } = require('short-uuid');


const useStyles = makeStyles((theme) => ({
    dropzone: {
        border: '2px dashed #ccc',
        padding: theme.spacing(4),
        textAlign: 'center',
        color: '#999',
        cursor: 'pointer',
        'box-shadow': 'none',
        backgroundColor: '#fafafa',
        '&:hover': {
            backgroundColor: '#f0f0f0',
        },
    },
    uploadIcon: {
        fontSize: '3rem',
        marginBottom: theme.spacing(1),
    },
    fileList: {
        marginTop: theme.spacing(2),
    },
}));

export default function UploadAsset({ onClose, parent }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const { handleSubmit } = useForm();

    const allAssets = useSelector(getAssets);

    const [loading, setLoading] = useState(false);
    const [files, setFiles] = React.useState([]);
    
    const { blueprintId } = getDetailsFromUrl();


    const onUpload = () => {
        const isFileExist = allAssets.find(item => item?.assetName === files[0].name);
        if (isFileExist) {
            return;
        }

        let formData = new FormData()
        formData.append('blueprintId', blueprintId);
        formData.append('assetFile', files[0]);
        formData.append('type', 'file');
        formData.append('parent', parent);


        const fileData = { fileName: files[0].name, id: generate(), startTime: Date.now(), blueprint_id: blueprintId }
        setLoading(true);
        dispatch(startUploadProgress(fileData));
        dispatch(addAssets(formData, fileData));
        setLoading(false);
        onClose();
    }


    const onDrop = useCallback((acceptedFiles) => {
        // setFiles((prev) => [...prev, ...acceptedFiles]);
        if (acceptedFiles.length > 0) {
            const isDuplicate = allAssets.find(item => item?.assetName === acceptedFiles[0].name);
            acceptedFiles[0].error = isDuplicate ? 'File already exists' : null
            setFiles([acceptedFiles[0]]);
        }
    }, []);

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        multiple: false,
    });

    const handleRemove = (indexToRemove) => {
        setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
    };

    return (
        <CustomizedDialogs
            open={open}
            title="Upload Assets"
            handleClose={onClose}
            paperProps={{ style: { width: 700, maxWidth: 700 }, id: "upload_assets_modal" }}
            actions={
                <>
                    <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                        Cancel
                    </Button>
                    <Button id="upload_asset_btn" disabled={loading || files.length === 0 || files[0]?.error} onClick={handleSubmit(onUpload)} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                        {loading ? 'Uploading..' : 'Upload'}
                    </Button>
                </>
            }>
            <Box>
                <Paper className={classes.dropzone} {...getRootProps()}>
                    <input {...getInputProps()} />
                    <CloudUploadIcon className={classes.uploadIcon} />
                    <Typography variant="h6">Drag & Drop files here</Typography>
                    <Typography variant="body2" style={{ textAlign: 'center' }}>or</Typography>
                    <Button variant="contained" color="primary" onClick={open}>
                        Browse Files
                    </Button>
                </Paper>

                {files?.length > 0 && <List className={classes.fileList}>
                    {files.map((file, index) => (
                        <ListItem key={index} id={`file_name_${file.name}`}>
                            <ListItemText
                                primary={file.name}
                                secondary={`${(file.size / 1024).toFixed(2)} KB`}
                            />
                            {file.error && (
                                <Typography variant="body2" style={{ color: 'red' }}>
                                    {file.error}
                                </Typography>
                            )}
                            <IconButton edge="end" onClick={() => handleRemove(index)} id={`file_delete_btn_${file.name}`}>
                                <DeleteIcon />
                            </IconButton>
                        </ListItem>
                    ))}
                </List>}
            </Box>

        </CustomizedDialogs>
    );

}